import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ShowOptions } from '../../../model/models';
import { ParametersProps } from '../../wizard/WizardSteps';
import { ParameterSelect } from '../ParameterSelect';
import { ParameterToggle } from '../ParameterToggle';

interface ConfidentialityOption {
  value: string;
  label: string;
  description: string;
}

export const DirectoryParameters: React.FC<ParametersProps> = ({
  user,
  updateParameter,
  parameters,
  isSetLoading,
}) => {
  const intl = useIntl();

  const CONFIDENTIALITY_OPTIONS: Array<ConfidentialityOption> = [
    {
      value: 'public',
      label: intl.formatMessage({ id: 'Confidentiality CIUP' }),
      description: intl.formatMessage({
        id: 'Confidentiality CIUP description',
      }),
    },
    {
      value: 'house',
      label: intl.formatMessage({ id: 'Confidentiality House' }),
      description: intl.formatMessage({
        id: 'Confidentiality House description',
      }),
    },
    {
      value: 'private',
      label: intl.formatMessage({ id: 'Confidentiality Private' }),
      description: intl.formatMessage({
        id: 'Confidentiality Private description',
      }),
    },
  ];

  const [showConfidentialityOptions, setShowConfidentialityOptions] =
    useState<boolean>(parameters.confidentiality !== 'private');

  const [confidentiality, setConfidentiality] = useState<string>(
    parameters.confidentiality
  );

  const [showOptions, setShowOptions] = useState<ShowOptions>({
    ...parameters.show,
  });

  const updateShow = (showType: string, value: boolean) => {
    const newShowOptions: ShowOptions = { ...showOptions, [showType]: value };
    setShowOptions(newShowOptions);
    updateParameter('show', newShowOptions);
  };

  useEffect(() => {
    if (parameters) {
      isSetLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="text-left text-sm ion-text-wrap profile-content mt-12">
      <ul className="mt-4">
        <ParameterSelect
          title="Level of confidentiality"
          name="confidentiality"
          value={confidentiality}
          options={CONFIDENTIALITY_OPTIONS}
          description={
            CONFIDENTIALITY_OPTIONS.find(
              (option) => option.value === confidentiality
            )?.description
          }
          onChange={(event) => {
            setConfidentiality(event.target.value);
            setShowConfidentialityOptions(event.target.value !== 'private');
            updateParameter(event.target.name, event.target.value);
          }}
        />
        <ParameterToggle
          title="Show my profile picture"
          name="showimage"
          visible={showConfidentialityOptions}
          checked={showOptions.image ? showOptions.image : false}
          onChange={(e) => updateShow('image', e.detail?.checked)}
        />
        <ParameterToggle
          title="Show my phone number"
          name="showmobile"
          visible={showConfidentialityOptions}
          checked={showOptions.mobile ? showOptions.mobile : false}
          onChange={(e) => updateShow('mobile', e.detail?.checked)}
        />
        <ParameterToggle
          title="Show my email address"
          name="showemail"
          visible={showConfidentialityOptions}
          checked={showOptions.email ? showOptions.email : false}
          onChange={(e) => updateShow('email', e.detail?.checked)}
        />
        <ParameterToggle
          title="Show my name"
          name="showname"
          visible={showConfidentialityOptions}
          checked={showOptions.name ? showOptions.name : false}
          onChange={(e) => updateShow('name', e.detail?.checked)}
        />
        <ParameterToggle
          title="Show my house"
          name="showhouse"
          visible={showConfidentialityOptions}
          checked={showOptions.house ? showOptions.house : false}
          onChange={(e) => updateShow('house', e.detail?.checked)}
        />
      </ul>
    </div>
  );
};
